import { ReactComponent as AgencyRecruitmentIcon } from "../../icons/agency-recruitment.svg";
import { ReactComponent as TalkToOurExpertsIcon } from "../../icons/talk-to-our-experts.svg";
import { ReactComponent as DjangoIcon } from "../../icons/frameworks/django.svg";
import { ReactComponent as DrupalIcon } from "../../icons/frameworks/drupal.svg";
import { ReactComponent as MagentoIcon } from "../../icons/frameworks/magento.svg";
import { ReactComponent as LaravelIcon } from "../../icons/frameworks/laravel.svg";
import { ReactComponent as NextjsIcon } from "../../icons/frameworks/nextjs.svg";
import { ReactComponent as GoIcon } from "../../icons/languages/go.svg";
import { ReactComponent as JavaIcon } from "../../icons/languages/java.svg";
import { ReactComponent as NodejsIcon } from "../../icons/languages/nodejs.svg";
import { ReactComponent as PhpIcon } from "../../icons/languages/php.svg";
import { ReactComponent as PythonIcon } from "../../icons/languages/python.svg";
import { ReactComponent as WordpressIcon } from "../../icons/frameworks/wordpress.svg";
import { ReactComponent as SymfonyIcon } from "../../icons/frameworks/symfony.svg";
import { ReactComponent as RubyIcon } from "../../icons/languages/ruby.svg";
import { ReactComponent as AgencyPortalIcon } from "../../icons/agency-portal.svg";
const headerDataFR = {
  homepage: "/fr/",
  top: [
    {
      //text: "Nous contacter",
      text: "Contact us",
      href: "/contact-us/",
    },
    {
      //text: "Documentation",
      text: "Documentation",
      href: "https://devcenter.upsun.com/",
    },
    {
      //text: "Connexion",
      text: "Login",
      href: "https://auth.upsun.com/",
    },
  ],
  links: [
    {
      text: "Produit",
      columns: [
        {
          title: "Produit",
          links: [
            {
              text: "Aperçu",
              href: "/fr/produit/"
            },
            {
              //text: "Fonctionnalités",
              text: "Features",
              href: "/features/"
            },
          ]
        },
        {
          title: "Frameworks",
          links: [
            {
              text: "Django",
              href: "/django/",
              icon: <DjangoIcon />
            },
            {
              text: "Next.js",
              href: "/nextjs/",
              icon: <NextjsIcon />
            },
            {
              text: "Drupal",
              href: "/drupal/",
              icon: <DrupalIcon />
            },
            {
              text: "WordPress",
              href: "/wordpress/",
              icon: <WordpressIcon />
            },
            {
              text: "Symfony",
              href: "/symfony/",
              icon: <SymfonyIcon />
            },
            {
              text: "Magento",
              href: "/magento/",
              icon: <MagentoIcon />
            },
            {
              text: "Laravel",
              href: "/laravel/",
              icon: <LaravelIcon />
            }
          ]
        },
        {
          //title: "Sprachen",
          title: "Languages",
          links: [
            {
              text: "PHP",
              href: "/php/",
              icon: <PhpIcon />
            },
            {
              text: "Python",
              href: "/python/",
              icon: <PythonIcon />
            },
            {
              text: "Node.js",
              href: "/nodejs/",
              icon: <NodejsIcon />
            },
            {
              text: "Ruby",
              href: "/ruby/",
              icon: <RubyIcon />
            },
            {
              text: "Java",
              href: "/java/",
              icon: <JavaIcon />
            },
            {
              text: "Golang",
              href: "/go/",
              icon: <GoIcon />
            }
          ]
        }
      ]
    },
    {
      text: "Solutions",
      columns: [
        {
          title: "Solutions",
          links: [
            {
              text: "Hébergement SaaS",
              href: "/fr/solutions/saas/"
            },
            {
              text: "Application modernisation",
              href: "/fr/solutions/application-modernisation/"
            },
            {
              text: "Commerce électronique",
              href: "/fr/solutions/commerce-electronique/"
            },
            {
              text: "Hébergement CMS",
              href: "/fr/solutions/cms/"
            },
            {
              text: "Gestion multi sites",
              href: "/fr/solutions/gestion-multi-sites/"
            },
            { 
              text: "Extensions SaaS",
              href: "/fr/solutions/saas-extensions/"
            },
            {
              text: "Solutions backend",
              href: "/fr/solutions/backend/"
            },
          ]
        },
        {
          title: "Industrie",
          links: [
            {
              text: "Vente au détail",
              href: "/fr/industrie/vente-au-detail/"
            },
            {
              text: "Enseignement supérieur",
              href: "/fr/industrie/enseignement-superieur/"
            },
            {
              text: "SaaS",
              href: "/fr/industrie/saas/"
            },
            {
              text: "Voyage et hôtellerie",
              href: "/fr/industrie/voyage-et-hotellerie/"
            },
            {
              text: "Services financiers",
              href: "/fr/industrie/services-financiers/"
            },
            {
              text: "Gouvernement",
              href: "/fr/industrie/gouvernement/"
            },
          ]
        }
      ]
    },
    {
      //text: "Tarification",
      text: "Pricing",
      columns: [
        {
          title: "Plans",
          links: [
            {
              text: "Flexible resources",
              href: "/pricing/"
            },
            {
              text: "Fixed resources",
              href: "/fixed-pricing/"
            },
          ]
        }
      ]
    },
    {
      //text: "Partenaires",
      text: "Partners",
      emphasizeFirstCol: true,
      columns: [
        {
          title: "Expertise",
          links: [
            {
              // TODO: translate
              "text": "Strategic Implementation",
              "href": "/strategic-implementation-experts/",
              "desc": "Tap upsun's implementation architects for the clarity and technical pathways that turn complex projects into confident launches.",
              "cta": "See how we can help"
            }
          ]
        },
        {
          title: "",
          links: [
            {
              // TODO: translate
              "text": "Get implementation help",
              "href": "/strategic-implementation-experts/",
              "icon": <TalkToOurExpertsIcon />
            },
            {
              // TODO: translate
              "text": "Become an agency partner",
              "href": "/agency-hosting-partner/",
              "icon": <AgencyRecruitmentIcon />
            },
            {
              "text": "Log to your portal",
              "href": "https://agencypartner.platform.sh",
              "icon": <AgencyPortalIcon /> 
            },
          ]
        }
      ]
    },
    {
      text: "Entreprise",
      emphasizeFirstCol: true,
      columns: [
        {
          //"title": "Communauté",
          title: "Community",
          "links": [
            {
              //"text": "Développeurs",
              text: "Developers",
              "href": "https://devcenter.upsun.com/",
              //desc: "Hub dédié aux dernières ressources de développement Upsun : trouvez des démos, de la documentation et des articles pour les frameworks et langages de votre choix",
              desc: "Hub for the latest Upsun developer resources: find demos, documentation and articles for your preferred frameworks and languages",
              //cta: "Découvrir",
              cta: "Check it out",
            },
          ]
        },
        {
          "title": "Ressources",
          "links": [
            {
              "text": "Études de cas",
              "href": "/fr/blog/etudes-de-cas/"
            },
            {
              "text": "Blog",
              "href": "/fr/blog/"
            },
            {
              // TODO: translate
              "text": "Trust center",
              "href": "/trust-center/"
            },
          ]
        },
        {
          "title": "Aperçu",
          "links": [
            {
              //"text": "Événements",
              text: "Events",
              "href": "/events/",
            },
            {
              "text": "Nouvelles de l'entreprise",
              "href": "/fr/blog/nouvelles/"
            },
            {
              //"text": "À propos de nous",
              text: "About us",
              "href": "/about-us/",
            },
            {
              //"text": "Emplois",
              text: "Jobs",
              "href": "/jobs/"
            },
            {
              //"text": "Développement durable",
              text: "Sustainability",
              "href": "/greener-hosting/",
            },
            {
              "text": "FAQ",
              "href": "/faq/",
            }
          ]
        }
      ]
    },
  ],
  ctas: [
    {
      // TODO: translate
      text: "Watch a demo",
      href: "/demo/",
    },
    {
      //text: "Essai gratuit",
      text: "Free trial",
      href: "https://auth.upsun.com/register",
    },
  ],
}

export default headerDataFR;